import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FormatBold from "@mui/icons-material/FormatBold";
import { IconButton, Tooltip } from "@mui/material";
import { FORMAT_TEXT_COMMAND } from "lexical";
import { type FC, useCallback } from "react";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import type { ToolbarProps } from "./props";

export const BoldButton: FC<ToolbarProps & { active: boolean }> = ({ disabled, active, mode }) => {
  const [editor] = useLexicalComposerContext();

  const onClick = useCallback(() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold"), [editor]);

  return (
    <Tooltip title="Bold">
      <IconButton
        data-analytics-id={`lexical-${mode}-bold`}
        disabled={disabled}
        data-testid={`${mode}-button-bold`}
        data-active={active}
        aria-pressed={active}
        aria-label="Bold"
        tabIndex={-1}
        sx={{
          ...floatingToolbarStyles[mode].button,
          backgroundColor: active ? "background.active" : "background.neutral",
        }}
        onClick={onClick}
      >
        <FormatBold sx={floatingToolbarStyles[mode].formatIcon} />
      </IconButton>
    </Tooltip>
  );
};
